<script setup lang="ts">
import FileManager from '@/components/FileManager.vue'
</script>

<template>
  <FileManager />
</template>

<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
</style>
